exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wide__bCIL.open__baq4 {\n  width: calc(100% + 40px); }\n\n.wide__bCIL.openRight__20cD {\n  width: 100%; }\n  @media all and (max-height: 1000px) {\n    .wide__bCIL.openRight__20cD {\n      width: calc(100% + 40px); } }\n\n.openRight__20cD {\n  right: 0; }\n", "", {"version":3,"sources":["/app/src/components/dropdown/src/components/dropdown/dropdown-list.scss"],"names":[],"mappings":"AAAA;EACE,yBAAW,EACZ;;AAED;EACE,YAAY,EAIb;EAHC;IAFF;MAGI,yBAAW,EAEd,EAAA;;AAED;EACE,SAAS,EACV","file":"dropdown-list.scss","sourcesContent":[".wide.open {\n  width: calc(100% + 40px);\n}\n\n.wide.openRight {\n  width: 100%;\n  @media all and (max-height: 1000px){\n    width: calc(100% + 40px);\n  }\n}\n\n.openRight {\n  right: 0;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wide": "wide__bCIL",
	"open": "open__baq4",
	"openRight": "openRight__20cD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/dropdown/dropdown-list.scss
// module id = 870
// module chunks = 0